var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "6.2942mm",
    height: "6.3916mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 53.25 54.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1904708153184"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.49,
    y: 1.49,
    width: 50.27,
    height: 51.09,
    rx: 7.6,
    ry: 7.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M9.09 0l35.07 0c2.5,0 4.77,1.02 6.41,2.67 1.65,1.65 2.67,3.92 2.67,6.42l0 35.9c0,2.5 -1.02,4.77 -2.67,6.41 -1.65,1.65 -3.92,2.67 -6.42,2.67l-35.07 0c-2.5,0 -4.77,-1.02 -6.41,-2.67 -1.65,-1.65 -2.67,-3.92 -2.67,-6.42l0 -35.9c0,-2.5 1.02,-4.77 2.67,-6.41 1.65,-1.65 3.92,-2.67 6.42,-2.67zm35.07 2.98l-35.07 0c-1.68,0 -3.21,0.69 -4.31,1.79 -1.1,1.11 -1.79,2.63 -1.79,4.31l0 35.9c0,1.68 0.69,3.21 1.79,4.31 1.11,1.1 2.63,1.79 4.31,1.79l35.07 0c1.68,0 3.21,-0.69 4.31,-1.79 1.1,-1.11 1.79,-2.63 1.79,-4.31l0 -35.9c0,-1.68 -0.69,-3.21 -1.79,-4.31 -1.11,-1.1 -2.63,-1.79 -4.31,-1.79z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "black",
    stroke: "black",
    strokeWidth: 1.69,
    strokeMiterlimit: 22.9256,
    points: "37.11,26.58 27.97,32.43 18.82,38.29 18.82,26.58 18.82,14.86 27.97,20.72 "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.29510bc4238e4b9165b094c260ecd051.svg";
export { ForwardRef as ReactComponent };